import { api } from '../api'
import { useIsAvailable } from './useIsAvailable'

export function useSettings() {
	const isAvailable = useIsAvailable()

	return api.useSettingsQuery(undefined, {
		skip: !isAvailable
	})
}
